// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"78":"f8613004","171":"cd0f5db2","265":"02024cac","288":"c449ae7e","409":"787d3cc2","541":"e92ef95f","618":"01e134e8","738":"bda229c7","763":"297e6141","774":"32fb70dc"}[chunkId] + ".chunk.js";
};